import { MenuType } from './permissions';

/**
 * The sidebar menu, and the single source of truth for which menu a route
 * belongs to. `PermissionService` filters this list for the menu and picks the
 * landing route from it, so a user can never be redirected to a route they
 * can't access.
 *
 * An item is shown when the user holds `Read` on its `menuType`.
 */
export interface NavItem {
  label: string;
  icon: string;
  route: string;
  /** The `menuType` id this item (and its route) belongs to. */
  menuType: MenuType;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Dashboard', icon: 'dashboard.svg', route: '/dashboard', menuType: MenuType.Dashboard },
  { label: 'Users & Access', icon: 'user-access.svg', route: '/users', menuType: MenuType.User },
  { label: 'Organizations', icon: 'organizations.svg', route: '/organizations', menuType: MenuType.Organization },
  { label: 'Org Masters Data', icon: 'master.svg', route: '/masters', menuType: MenuType.Masters },
  { label: 'Security Policy', icon: 'security-policy.svg', route: '/security-policy', menuType: MenuType.Policy },
  { label: 'Audit Logs', icon: 'audit-logs.svg', route: '/audit-logs', menuType: MenuType.Audit },
] as const;

/**
 * Where to send a user who has no accessible menu item. Profile carries no
 * permission requirement, so this always resolves.
 */
export const FALLBACK_ROUTE = '/profile';
